import { render, staticRenderFns } from "./client-details.vue?vue&type=template&id=1802e1ab&scoped=true&"
import script from "./client-details.vue?vue&type=script&lang=js&"
export * from "./client-details.vue?vue&type=script&lang=js&"
import style0 from "./client-details.vue?vue&type=style&index=0&id=1802e1ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1802e1ab",
  null
  
)

export default component.exports